import React, { useCallback, useEffect, useState } from 'react';

import MToolbarView from './MToolbar.view';

import { IMenu } from './MToolbar.model';

interface Props {
  menu: IMenu[];
  logo?: string;
  className?: string;
  onLogoClick: () => void;
}

const MToolbar: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const [platformState, setPlatformState] = useState<'mobile' | 'desktop'>(document.body.clientWidth < 768 ? 'mobile' : 'desktop');
  const [showMobileMenu, setShowMobileMenu] = useState<boolean>(false);

  useEffect(() => {
    const checkPlatform = () => {
      const platform = document.body.clientWidth < 768 ? 'mobile' : 'desktop';

      setPlatformState(() => platform);

      if (platform === 'desktop') {
        setShowMobileMenu(() => false);
      }
    };

    window.addEventListener('resize', checkPlatform, true);

    return window.removeEventListener('resize', checkPlatform);
  }, [setShowMobileMenu, setPlatformState]);

  const closeMobileMenu = useCallback(() => {
    setShowMobileMenu(() => false);
  }, [setShowMobileMenu]);

  return (
    <MToolbarView
      onMobileMenuExit={closeMobileMenu}
      onMobileMenuClick={() => setShowMobileMenu(() => true)}
      mobileMenu={showMobileMenu}
      platform={platformState}
      menu={props.menu}
      logo={props.logo}
      className={props.className}
      onLogoClick={props.onLogoClick}
    >
      {props.children}
    </MToolbarView>
  );
};

MToolbar.displayName = 'MToolbar';
MToolbar.defaultProps = {};

export default MToolbar;
